<div class="card">
  <div class="card-header">
    <h2 class="card-title">Gerenciamento de Produtos</h2>
    <button mat-fab extended color="primary" (click)="openProductDialog()">
      <mat-icon>add</mat-icon>
      Novo Produto
    </button>
  </div>

  <div class="card-body">
      <!-- TABS DE NAVEGAÇÃO -->
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
        <mat-tab label="Todos os Produtos">
          <ng-container *ngTemplateOutlet="productContent"></ng-container>
        </mat-tab>
        <mat-tab label="Apenas Ativos">
          <ng-container *ngTemplateOutlet="productContent"></ng-container>
        </mat-tab>
      </mat-tab-group>

      <!-- TEMPLATE DE CONTEÚDO -->
      <ng-template #productContent>
        <!-- TABELA DE PRODUTOS -->
        <div class="table-container">
          <h3 class="title-section">
            @if (currentView === 'all') {
              Lista de Produtos
            } @else {
              Produtos Ativos
            }
          </h3>

          <table mat-table [dataSource]="products" class="products-table">
            <!-- Coluna ID -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let product">{{ product.id }}</td>
            </ng-container>

            <!-- Coluna Nome -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nome</th>
              <td mat-cell *matCellDef="let product">
                <strong>{{ product.name }}</strong>
              </td>
            </ng-container>

            <!-- Coluna Preço Base -->
            <ng-container matColumnDef="basePrice">
              <th mat-header-cell *matHeaderCellDef>Preço Base</th>
              <td mat-cell *matCellDef="let product">
                {{ formatPrice(product.basePrice) }}
              </td>
            </ng-container>

            <!-- Coluna Descrição -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let product" class="description-cell">
                {{ product.description || 'N/A' }}
              </td>
            </ng-container>

            <!-- Coluna Status com Badges -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let product">
                @if (getProductStatus(product) === 'inactive') {
                  <span class="badge badge-warning">
                    🟡 Inativo
                  </span>
                } @else {
                  <span class="badge badge-success">
                    🟢 Ativo
                  </span>
                }
              </td>
            </ng-container>

            <!-- Coluna Ações -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let product">
                <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="editProduct(product)">
                    <mat-icon>edit</mat-icon>
                    <span>Editar</span>
                  </button>
                  <button mat-menu-item (click)="toggleProductStatus(product)">
                    <mat-icon>{{ product.active ? 'block' : 'check_circle' }}</mat-icon>
                    <span>{{ product.active ? 'Desativar' : 'Ativar' }}</span>
                  </button>
                  <mat-divider></mat-divider>
                  <button mat-menu-item (click)="deleteProduct(product.id!)" class="delete-action">
                    <mat-icon>delete</mat-icon>
                    <span>Excluir</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                Nenhum produto encontrado
              </td>
            </tr>
          </table>

          <div class="table-footer">
            <small>Total de produtos: {{ products.length }}</small>
          </div>
        </div>
      </ng-template>
  </div>
</div>